var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBpSwitchBefore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5139_9982)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#6D47FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 3.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#F4F4F4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2666 8.09278C18.2666 7.51415 17.7756 7.05214 17.2048 7.14673C15.8405 7.37279 14.5278 7.85465 13.337 8.57024C11.8399 9.4699 10.5786 10.7131 9.65735 12.197C8.73613 13.681 8.18152 15.3629 8.03941 17.1037C7.89729 18.8445 8.17175 20.5942 8.84009 22.2079C9.50842 23.8216 10.5514 25.2529 11.8828 26.3835C13.2141 27.514 14.7955 28.3113 16.4962 28.7093C18.1968 29.1074 19.9678 29.0947 21.6626 28.6724C23.0106 28.3365 24.2797 27.7491 25.4043 26.9443C25.8748 26.6076 25.8953 25.9338 25.4862 25.5246L18.4866 18.5236C18.4169 18.4553 18.3616 18.3738 18.3238 18.2839C18.286 18.194 18.2666 18.0975 18.2666 18V8.09278Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5246 24.4876C26.9333 24.8962 27.6062 24.8764 27.9433 24.407C29.2788 22.5473 30.0035 20.3073 30.0001 18C30.0016 16.8967 29.8366 15.8016 29.5125 14.7512C29.3419 14.1984 28.7092 13.966 28.1917 14.2247L21.479 17.5805C20.8685 17.8857 20.7364 18.6994 21.2191 19.182L26.5246 24.4876ZM27.5334 12.9135C28.0508 12.6548 28.2445 12.0093 27.9049 11.541C27.0654 10.3832 26.0059 9.39739 24.7836 8.64188C23.5613 7.88639 22.2058 7.37956 20.7949 7.14631C20.2241 7.05195 19.7334 7.51391 19.7334 8.09241V15.1954C19.7334 15.9388 20.5157 16.4223 21.1806 16.0898L27.5334 12.9135Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5139_9982",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5139_9982"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5139_9982",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpSwitchBefore);
export default __webpack_public_path__ + "static/media/BPSwitchBefore.8f72cf9c0a6e8efcac8c48a09062beaa.svg";
export { ForwardRef as ReactComponent };